import React, { useState } from 'react';
import { Play, X, Phone } from 'lucide-react';
import { CLINIC, VIDEOS } from '../mock';
import { PageHero, SectionTitle, Reveal } from '../components/Shared';
import { VideoTestimonial } from '../components/VideoTestimonial';
import { RadioFeature, PressGallery } from '../components/Recognition';

export default function VideoGallery() {
  const [active, setActive] = useState(null);

  return (
    <div>
      <PageHero eyebrow="Media & Video Gallery" title="Learn from our video library" subtitle="Short, easy-to-understand videos about arthritis, autoimmune conditions and modern treatments." />

      <section className="pt-20">
        <div className="container-x">
          <SectionTitle center eyebrow="Patient Stories" title="Video testimonials" />
          <VideoTestimonial idPrefix="gallery-video-testimonial" />
          <div className="mt-16">
            <SectionTitle center eyebrow="On Air" title="Dr Puneet on radio" />
            <div className="max-w-3xl mx-auto"><RadioFeature idPrefix="gallery-radio-feature" /></div>
          </div>
          <div className="mt-16">
            <SectionTitle center eyebrow="Print Media" title="In the press" />
            <PressGallery />
          </div>
        </div>
      </section>

      <section className="py-20">
        <div className="container-x">
          <SectionTitle center eyebrow="Watch & Learn" title="Patient education videos" />
          <div className="grid md:grid-cols-3 sm:grid-cols-2 gap-6">
            {VIDEOS.map((v, i) => (
              <Reveal key={v.id} delay={(i % 3) * 80}>
                <button onClick={() => setActive(v)} className="group text-left w-full card-lift bg-white rounded-2xl overflow-hidden border border-teal-50">
                  <div className="relative h-48 overflow-hidden">
                    <img src={`https://img.youtube.com/vi/${v.id}/hqdefault.jpg`} alt={v.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-teal-900/25 group-hover:bg-teal-900/40 transition-colors" />
                    <span className="absolute inset-0 grid place-items-center">
                      <span className="grid place-items-center w-16 h-16 rounded-full bg-white/90 text-teal-700 shadow-lg group-hover:scale-110 transition-transform"><Play size={26} className="ml-1 fill-teal-700" /></span>
                    </span>
                    <span className="absolute top-3 left-3 bg-white/90 text-teal-800 text-xs font-semibold px-3 py-1 rounded-full">{v.tag}</span>
                  </div>
                  <div className="p-5">
                    <h3 className="text-base text-teal-900 group-hover:text-teal-700 transition-colors" style={{ fontWeight: 600 }}>{v.title}</h3>
                  </div>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {active && (
        <div className="fixed inset-0 z-[80] grid place-items-center p-4" onClick={() => setActive(null)}>
          <div className="absolute inset-0 bg-teal-950/80 backdrop-blur-sm" />
          <div className="relative w-full max-w-4xl" onClick={(e) => e.stopPropagation()}>
            <button onClick={() => setActive(null)} className="absolute -top-12 right-0 grid place-items-center w-10 h-10 rounded-full bg-white/15 text-white hover:bg-white/25 transition-colors"><X size={22} /></button>
            <div className="rounded-2xl overflow-hidden shadow-2xl aspect-video bg-black">
              <iframe title={active.title} src={`https://www.youtube.com/embed/${active.id}?autoplay=1&rel=0`} className="w-full h-full border-0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
            <p className="text-white/90 text-center mt-4 font-medium">{active.title}</p>
          </div>
        </div>
      )}

      <section className="deep-section">
        <div className="container-x py-14 flex flex-col md:flex-row items-center justify-between gap-6">
          <h2 className="text-white text-2xl md:text-3xl text-balance" style={{ fontWeight: 600 }}>Have questions after watching?</h2>
          <a href={`tel:${CLINIC.phoneRaw}`} className="btn-coral inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold"><Phone size={18} /> Talk to a Specialist</a>
        </div>
      </section>
    </div>
  );
}
